export default {"src":"/polygon/_next/static/media/fund_17.74d2da0b.svg","height":80,"width":231};